import {useGTMDispatch} from './react-gtm-hook/index'
import {useDataCloudDispatch} from './data-cloud'
import {transformAlgoliaItemsForBasketEventsGA4} from './utils'
import { useRapidDeliveryStore } from '../store/hooks/useStore'

export const useAddToWishlistTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendDataToDataCloud = useDataCloudDispatch()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()

  const sendAddToWishlistData = (addToWishlistData) => {
    const { 
      product,
      cartLocation,
      viewingCategoryId,
      location,
      hitItemIndex
    } = addToWishlistData
    setTimeout(() => {
      try {
        const transformAlgoliaData = {
          items: [product],
          cartLocation,
          viewingCategoryId,
          location,
          hitItemIndex,
          isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForBasketEventsGA4(transformAlgoliaData)
        const currentPrice = product?.displayPrice || product?.price?.GBP || 0
        const eventData = {
          event: 'add_to_wishlist',
          ecommerce: {
            currency: 'GBP',
            value: currentPrice * _items[0].quantity,
            items: _items, 
          }
        }
        sendDataToGTM(eventData)
        sendDataToDataCloud(eventData)
      } catch (error) {
        console.error('useAddToWishlistTracking error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendAddToWishlistData
}